export function renderAppGrid(apps) {
    const appGrid = document.getElementById('app-grid');
    const emptyState = document.getElementById('app-grid-empty');
    const loading = document.getElementById('app-grid-loading');

    loading?.classList.add('is-hidden');
    appGrid.innerHTML = '';

    if (!apps.length) {
        appGrid.classList.add('is-hidden');
        emptyState.classList.remove('is-hidden');
        return;
    }

    appGrid.classList.remove('is-hidden');
    emptyState.classList.add('is-hidden');

    apps.forEach((app) => {
        createAppGridItem(app);
    });
}

function createAppGridItem(app) {
    const appGrid = document.getElementById('app-grid');

    const gridItem = document.createElement('div');
    gridItem.classList.add('app-grid-item');
    gridItem.setAttribute('role', 'listitem');
    gridItem.setAttribute('tabindex', '0');
    gridItem.setAttribute('aria-label', `Open ${app.name}`);

    const content = document.createElement('div');
    content.classList.add('app-grid-item-content');

    const img = document.createElement('img');
    // Required for canvas dominant-colour extraction from Storage logos
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    img.alt = '';
    img.src = app.logoUrl || app.logo || new URL('../../img/logo.svg', import.meta.url).href;

    const title = document.createElement('h4');
    title.textContent = app.name;

    content.appendChild(img);
    content.appendChild(title);

    gridItem.appendChild(content);
    appGrid.appendChild(gridItem);

    const applyBrandGradient = () => {
        try {
            const sampleSize = 64;
            const canvas = document.createElement('canvas');
            canvas.width = sampleSize;
            canvas.height = sampleSize;
            const context = canvas.getContext('2d', { willReadFrequently: true });
            context.drawImage(img, 0, 0, sampleSize, sampleSize);

            const colors = extractDominantColors(context, sampleSize, sampleSize, 3);
            if (!colors.length) {
                return;
            }

            const gradientColors = colors.map((color, index) => {
                const alpha = index === 0 ? 0.72 : 0.55;
                return rgbToRgba(color, alpha);
            });

            while (gradientColors.length < 2) {
                gradientColors.push(gradientColors[0]);
            }

            gridItem.style.setProperty(
                '--gradient-background',
                `linear-gradient(135deg, ${gradientColors.join(', ')})`
            );
            gridItem.classList.add('has-brand-gradient');
        } catch (_) {
            // Cross-origin logos may taint canvas — leave default surface
        }
    };

    if (img.complete && img.naturalWidth > 0) {
        applyBrandGradient();
    } else {
        img.addEventListener('load', applyBrandGradient, { once: true });
    }

    const openLink = () => {
        window.location.href = app.url;
    };

    gridItem.addEventListener('click', openLink);
    gridItem.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openLink();
        }
    });
}

function rgbToRgba(rgb, alpha) {
    const rgbArray = rgb.match(/\d+/g);
    return `rgba(${rgbArray[0]}, ${rgbArray[1]}, ${rgbArray[2]}, ${alpha})`;
}

function extractDominantColors(context, width, height, colorCount = 3) {
    const imageData = context.getImageData(0, 0, width, height);
    const data = imageData.data;
    const colorMap = {};

    for (let i = 0; i < data.length; i += 4) {
        const a = data[i + 3];
        if (a < 40) {
            continue;
        }

        // Quantise to keep near-duplicate logo colours together
        const r = Math.round(data[i] / 24) * 24;
        const g = Math.round(data[i + 1] / 24) * 24;
        const b = Math.round(data[i + 2] / 24) * 24;

        // Skip near-white / near-black chrome that swamps brand colour
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        if (max > 235 && min > 210) {
            continue;
        }
        if (max < 28) {
            continue;
        }

        const color = `rgb(${r},${g},${b})`;
        colorMap[color] = (colorMap[color] || 0) + 1;
    }

    const sortedColors = Object.entries(colorMap).sort((a, b) => b[1] - a[1]);
    const dominantColors = sortedColors.slice(0, colorCount).map((entry) => entry[0]);

    if (dominantColors.length >= 2) {
        return dominantColors;
    }
    if (dominantColors.length === 1) {
        return [dominantColors[0], dominantColors[0]];
    }
    return [];
}
